import { render, staticRenderFns } from "./Projects.html?vue&type=template&id=b3cc6062&scoped=true&"
import script from "./Projects.js?vue&type=script&lang=js&"
export * from "./Projects.js?vue&type=script&lang=js&"
import style0 from "./Projects.scss?vue&type=style&index=0&id=b3cc6062&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cc6062",
  null
  
)

export default component.exports